import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        const currentUserRole = this.authenticationService
            ?.getSessionRole()
            ?.toLowerCase() as string;
        const requiredRoles = route?.data['roles'] as string[];

        if (currentUser) {
            if (requiredRoles.includes(currentUserRole)) {
                return true;
            }

            this.router.navigate(['/']);
        }

        this.router.navigate(['/auth/login'], {
            queryParams: { returnUrl: state.url }
        });
        return false;
    }
}
